module.exports = __webpack_public_path__ + "img/jank_ind.ac0ea5f6.png";